import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="pt-24 pb-12 bg-[#050505] border-t border-white/10" role="contentinfo">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-20">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-8">
              <img
                src="https://lqpglobal.com/logocubo.png"
                alt="LQP Global - Soluciones digitales para pymes"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <h3 className="text-2xl font-bold mb-6 text-gradient">
              Mantente Conectado
            </h3>
            <p className="text-gray-500 mb-8 max-w-sm">
              Subscribite a nuestro newsletter para recibir las últimas actualizaciones sobre IA y automatización para pymes.
            </p>
            <form className="flex gap-2 max-w-md" onSubmit={(e) => e.preventDefault()}>
              <label htmlFor="footer-email" className="sr-only">Email</label>
              <input
                id="footer-email"
                type="email"
                placeholder="Tu email corporativo"
                autoComplete="email"
                className="flex-1 px-6 py-4 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-red-500 transition-colors"
              />
              <button type="submit" className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl transition-all">
                Suscribir
              </button>
            </form>
          </div>

          <nav aria-label="Enlaces del pie de página">
            <h4 className="text-white font-bold mb-6">Navegación</h4>
            <ul className="space-y-4 text-gray-500 text-sm">
              <li><Link to="/" className="hover:text-red-500 transition-colors">Inicio</Link></li>
              <li><Link to="/soluciones" className="hover:text-red-500 transition-colors">Soluciones</Link></li>
              <li><Link to="/nosotros" className="hover:text-red-500 transition-colors">Nosotros</Link></li>
              <li><Link to="/blog" className="hover:text-red-500 transition-colors">Blog Digital</Link></li>
              <li><Link to="/contacto" className="hover:text-red-500 transition-colors">Contacto</Link></li>
            </ul>
          </nav>

          <div>
            <h4 className="text-white font-bold mb-6">Contacto</h4>
            <address className="space-y-4 text-gray-500 text-sm not-italic">
              <div className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-sm" aria-hidden="true">📞</span>
                <a href="tel:+5491139416257" className="hover:text-white transition-colors">
                  +54 9 11 3941-6257
                </a>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-sm" aria-hidden="true">✉️</span>
                <a href="mailto:proyectos@lqpglobal.com" className="hover:text-white transition-colors">
                  proyectos@lqpglobal.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-sm" aria-hidden="true">📍</span>
                Buenos Aires, Argentina
              </div>
            </address>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/5 text-gray-600 text-sm">
          <p>© {new Date().getFullYear()} LQP Global. Todos los derechos reservados.</p>
          <div className="flex gap-6 mt-6 md:mt-0">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/globallqp"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-all transform hover:scale-110"
              aria-label="Seguinos en Instagram"
            >
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.975.975 1.245 2.242 1.308 3.607.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.332 2.633-1.308 3.608-.975.975-2.242 1.245-3.607 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.332-3.608-1.308-.975-.975-1.245-2.242-1.308-3.607-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.332-2.633 1.308-3.608.975-.975 2.242-1.245 3.607-1.308 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            {/* Facebook */}
            <a
              href="https://www.facebook.com/profile.php?id=61575910386766"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-all transform hover:scale-110"
              aria-label="Seguinos en Facebook"
            >
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
              </svg>
            </a>
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/lqpglobal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-white transition-all transform hover:scale-110"
              aria-label="Seguinos en LinkedIn"
            >
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.238 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
